import React, { useEffect } from 'react';
import { useHome } from './hooks/Home.hook';
import HomeView from './views/HomeView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const HomeController = () => {
  const {
    isLoading,
    doctors,
    loadDoctors,
    error,
    filteredDoctorList,
    setFilteredDoctorList,
    listaEspecialidades,
    changueEspFilter,
    selectedSpeciality,
    setSelectedDoctor,
    selectedDoctor,
    changeDoctorFilter,
    medicalHistory,
    isLoadingHistory,
    historyError,
    selectedSchedule,
    selectSchedule,
    doctorServices,
    selectedService,
    selectService,
    personalData,
    isLoadingPersonal,
    personalError,
    validationSchemaFacturacion,
    saveMedicalHistory,
    patientInformation,
    setPatientInformation,
    patientsxUser,
    loadingSaveHistory,
    getPatientsForDoctor,
    isLoadingPatientsxUser,
    isLoadingSpeciality,
    isLoadingDoctor,
    setIsLoadingDoctor,
    returnMedicalHistoryForPay
  } = useHome();

  useEffect(() => {
    if (doctors.length === 0) {
      loadDoctors();
    }
  }, []);

  useEffect(() => {
    if (doctors) {
      setFilteredDoctorList(doctors);
    }
  }, [doctors]);

  if (isLoading) {
    return <LoadingComponent loading={isLoading} />;
  } else {
    return (
      <HomeView
        error={error}
        filteredDoctorList={filteredDoctorList}
        setFilteredDoctorList={setFilteredDoctorList}
        listaEspecialidades={listaEspecialidades}
        changueEspFilter={changueEspFilter}
        selectedSpeciality={selectedSpeciality}
        setSelectedDoctor={setSelectedDoctor}
        selectedDoctor={selectedDoctor}
        changeDoctorFilter={changeDoctorFilter}
        medicalHistory={medicalHistory}
        isLoadingHistory={isLoadingHistory}
        historyError={historyError}
        selectedSchedule={selectedSchedule}
        selectSchedule={selectSchedule}
        doctorServices={doctorServices}
        selectedService={selectedService}
        selectService={selectService}
        personalData={personalData}
        isLoadingPersonal={isLoadingPersonal}
        personalError={personalError}
        validationSchemaFacturacion={validationSchemaFacturacion}
        saveMedicalHistory={saveMedicalHistory}
        patientInformation={patientInformation}
        setPatientInformation={setPatientInformation}
        patientsxUser={patientsxUser}
        loadingSaveHistory={loadingSaveHistory}
        getPatientsForDoctor={getPatientsForDoctor}
        isLoadingPatientsxUser={isLoadingPatientsxUser}
        isLoadingSpeciality={isLoadingSpeciality}
        isLoadingDoctor={isLoadingDoctor} 
        setIsLoadingDoctor={setIsLoadingDoctor}
        returnMedicalHistoryForPay={returnMedicalHistoryForPay}
      />
    );
  }
};

export default HomeController;
